import { render, staticRenderFns } from "./linteam.vue?vue&type=template&id=6cd9406c&scoped=true"
import script from "./linteam.vue?vue&type=script&lang=js"
export * from "./linteam.vue?vue&type=script&lang=js"
import style0 from "./linteam.vue?vue&type=style&index=0&id=6cd9406c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9406c",
  null
  
)

export default component.exports